// src/LandingPage.js
import React, { useEffect, useState } from "react";
import { supabase } from "./supabaseClient";
import "./LandingPage.css";
import demoImage from "./malaria-demo.png";
import { v4 as uuidv4 } from "uuid";

function LandingPage() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [profession, setProfession] = useState("");
  const [submitted, setSubmitted] = useState(false);

  // Enregistrer la visite
  useEffect(() => {
    const insertVisit = async () => {
      try {
        // Générer ou récupérer l'ID visiteur
        let visitorId = localStorage.getItem("visitor_id");
        if (!visitorId) {
          visitorId = uuidv4();
          localStorage.setItem("visitor_id", visitorId);
        }

        // Insérer la visite
        const { data: visit, error } = await supabase
          .from("visits")
          .insert([{ visitor_id: visitorId, timestamp: new Date() }])
          .select()
          .single();

        if (error) {
          console.error("Erreur insertion visite :", error);
        } else {
          // Sauvegarder l'ID de la visite pour lier à l'inscription
          localStorage.setItem("visit_id", visit.id);
        }
      } catch (err) {
        console.error(err);
      }
    };

    insertVisit();
  }, []);

  // Soumission du formulaire
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Créer l'inscription
      const { data: signup, error: signupError } = await supabase
        .from("signups")
        .insert([{ name, email, profession, timestamp: new Date() }])
        .select()
        .single();

      if (signupError) {
        console.error("Erreur inscription :", signupError);
        return;
      }

      // Lier la visite à cette inscription
      const visitId = localStorage.getItem("visit_id");
      if (visitId) {
        const { error: visitError } = await supabase
          .from("visits")
          .update({ signup_id: signup.id })
          .eq("id", visitId);

        if (visitError)
          console.error("Erreur mise à jour visite :", visitError);
      }

      setSubmitted(true);
      setName("");
      setEmail("");
      setProfession("");
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="container">
      {/* Hero Section */}
      <header className="hero">
        <h1>Malaria-Scan</h1>
        <p>Détection du paludisme plus rapide qu’un microscope classique</p>
      </header>

      {/* Pitch / Demo Section */}
      <section className="pitch">
        <h2>Pourquoi Malaria-Scan ?</h2>
        <ul>
          <li>Analyse rapide des frottis sanguins</li>
          <li>Gain de temps pour vos diagnostics</li>
          <li>Haute précision et seuil de détection élevé</li>
          <li>Facile à intégrer dans votre workflow</li>
        </ul>

        <img
          src={demoImage}
          alt="Maquette Malaria-Scan"
          className="demo-image"
        />
      </section>

      {/* Form Section */}
      <section className="form-section">
        {!submitted ? (
          <form className="form" onSubmit={handleSubmit}>
            <h2>Inscrivez-vous pour une démo</h2>
            <input
              type="text"
              placeholder="Nom"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <select
              value={profession}
              onChange={(e) => setProfession(e.target.value)}
              required
            >
              <option value="">Profession</option>
              <option value="Laborantin">Laborantin</option>
              <option value="Pharmacien">Pharmacien</option>
              <option value="Médecin">Médecin</option>
            </select>
            <button type="submit">Demander ma démo</button>
          </form>
        ) : (
          <p className="thank-you">Merci ! Nous vous contacterons bientôt.</p>
        )}
      </section>
    </div>
  );
}

export default LandingPage;
